import React, {useState, useEffect} from 'react';
import Modal from '../../Components/Modal';
import Form, { Actions } from '../../Components/Form';
import TermsOfService from './Templates/TermsOfService';
import PrivacyPolicy from './Templates/PrivacyPolicy';
import { PageLoading } from '../../Components/Loading';
import { useSession } from '../../Components/Session';
import { ulid } from 'ulid';
import { useToasts } from '../../Components/Toasts';

const TemplateOptions = ({document, isOpen, setIsOpen, generateDocument, refresh, checkForGenerationComplete}) => {
    const {business, user} = useSession();
    const [waitingForGeneration, setWaitingForGeneration] = useState(false);

    return <Modal title={waitingForGeneration ? null : 'Update Document'} isOpen={isOpen} setIsOpen={setIsOpen} dismissible>
        <Content {...{isOpen, setIsOpen, document, generateDocument, business, user, refresh, waitingForGeneration, setWaitingForGeneration, checkForGenerationComplete}} />
    </Modal>
}

const Content = ({isOpen, setIsOpen, document, generateDocument, business, user, checkForGenerationComplete, waitingForGeneration, setWaitingForGeneration}) => {
    if (!isOpen) {
        return null;
    }

    const ready = business && user && document;

    if (isOpen && waitingForGeneration) {
        return <WaitForGeneration {...{document, checkForGenerationComplete, waitingForGeneration, setWaitingForGeneration, setIsOpen}} />
    }

    if (isOpen && !ready) {
        return <PageLoading />
    }

    if (isOpen && ready) {
        return <Inner {...{document, generateDocument, business, user, setWaitingForGeneration}} />
    }

    return null;
}

let interval;
const WaitForGeneration = ({document, checkForGenerationComplete, waitingForGeneration, setWaitingForGeneration, setIsOpen}) => {
    const {showSuccess} = useToasts();

    useEffect(() => {
        clearInterval(interval);
        
        interval = setInterval(async () => {
            const finished = await checkForGenerationComplete(waitingForGeneration.generateId);
            if (finished) {
                showSuccess('Document generated');
                clearInterval(interval);
                setIsOpen(false);
                setWaitingForGeneration(false);
            }
        }, 2000);

        return () => clearInterval(interval);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [document,  waitingForGeneration]);

    return <PageLoading short message={`Generating your document.\nThis might take a moment.`} />
}

const Inner = ({document, generateDocument, business, user, setWaitingForGeneration}) => {
    const mergedOptions = {
        ...{
            businessLegalName: business.name,
            contactAddress: business.address,
            contactEmail: user.email,
            contactPhone: business.phoneNumber,
            subProcessors: `getSoapy Ltd\n`,
            version: '1.0',
        },
        ...(document.templateOptions ?? {}),
        // Make sure this comes last so it overrides the current generateId
        ...{
            generateId: ulid(),
        }
    };
    return <Form data={mergedOptions} onSubmit={generateDocument} afterSubmit={setWaitingForGeneration}>
        <TheTemplate template={document.templateClass} data={document.templateOptions} />
        <Actions submit={{label: 'Update'}} cancel />
    </Form>
}

const TheTemplate = ({template, templateOptions}) => {
    switch (template) {
        case 'TermsOfService':
            return <TermsOfService templateOptions={templateOptions} />
        case 'PrivacyPolicy':
            return <PrivacyPolicy templateOptions={templateOptions} />
        default:
            return <p className="text-muted text-center">Unknown template</p>
    }
}

export default TemplateOptions;
